<template>
  <div class="differentiating-benefits-comunit-content" id="plataforma-de-marca-beneficios-diferenciadores-comunidade" data-search-anchor>
    <div class="differentiating-benefits-comunit-overlay-title-image">
      <h1 class="differentiating-benefits-comunit-image-comunit-title" style="margin-top: 4rem;">
        {{ differentiatingBenefitsComunitImageTitle }}
      </h1>
      <h1 class="differentiating-benefits-comunit-image-comunit-title">
        {{ differentiatingBenefitsComunitImageTitle2 }}
      </h1>
      <h1 class="differentiating-benefits-comunit-image-comunit-title" style="margin-bottom: 2rem;">
        {{ differentiatingBenefitsComunitImageTitle3 }}
      </h1>
      <p class="differentiating-benefits-comunit-image-comunit-text" >
        {{ differentiatingBenefitsComunitImageTitle4 }}
      </p>
    </div>

    <div
      class="differentiating-benefits-comunit-banner-image"
      :style="{ backgroundImage: `url(${differentiatingBenefitsComunitImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import DifferentiatingBenefitsPageMixin from '@/mixins/differentiating-benefits-page-mixin'
import { DifferentiatingBenefitsPageStore } from '@/store/brand-plataform-page/differentiating-benefits-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class DifferentiatingBenefitsComunitSection extends Mixins(
  DifferentiatingBenefitsPageMixin
) {
  differentiatingBenefitsPageStore: PageStoreContract = getModule(
    DifferentiatingBenefitsPageStore,
    this.$store
  )

  get differentiatingBenefitsComunitImageTitle(): string {
    return this.getElementText(5, 0)
  }

  get differentiatingBenefitsComunitImageSrc(): string {
    return this.getElementMedia(5, 0)
  }

  get differentiatingBenefitsComunitImageTitle2(): string {
    return this.getElementText(5, 1)
  }

  get differentiatingBenefitsComunitImageTitle3(): string {
    return this.getElementText(5, 2)
  }

  get differentiatingBenefitsComunitImageTitle4(): string {
    return this.getElementText(5, 3)
  }

  async getDifferentiatingBenefitsPageStore(): Promise<void> {
    await this.differentiatingBenefitsPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.differentiatingBenefitsPageStore.isLoading) {
      await this.getDifferentiatingBenefitsPageStore()
    }
  }
}
</script>

<style lang="scss">
.differentiating-benefits-comunit-content {
  display: grid;
  grid-template-columns: 47% 53%;
  width: 100%;
  max-width: 1032px;
  margin-bottom: 4rem;  
}

.differentiating-benefits-comunit-banner-image {
  margin-top: 64px;
  position: relative;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  height: 600px;  
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.differentiating-benefits-comunit-overlay-title-image {
  max-width: 416px;
  width: 100%;
  height: 465px;
}

.differentiating-benefits-comunit-image-comunit-title {
  font-size: 40px;
  font-weight: 400;
  letter-spacing: -0.01em;  
  margin: 0;
}

.differentiating-benefits-comunit-image-comunit-text {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 32px;  
  width: 416px;
  margin: 0;
}
</style>
